import {io, Socket} from "socket.io-client"
import {Topic} from "../topics"

export default class SocketClient {
    private socket: Socket | undefined
    private host = "localhost"
    private eventEmitter: any

    constructor(host: string, eventEmitter: any) {
        this.host = host
        this.eventEmitter = eventEmitter
    }

    public connect(): void {
        this.socket = io(`${this.host}`)
        this.socket.on("connect", () => this.onConnect())
        this.socket.on("disconnect", () => this.onDisconnect())
        this.socket.on("message", (data) => this.onMessage(data))
    }

    public disconnect(): void {
        if (this.socket !== undefined) {
            this.socket.disconnect()
        }
    }

    private onConnect(): void {
        this.eventEmitter.emit(Topic.onSocketConnected)
    }

    private onDisconnect(): void {
        this.eventEmitter.emit(Topic.onSocketDisconnected)
    }

    private onMessage(data: any): void {
        if (typeof data === "string") {
            data = JSON.parse(data)
        }
        this.eventEmitter.emit(data.command, data.data)
    }

    public emit(command: string, data: object = {}, forwardMessage: boolean = false): void {
        if (this.socket !== undefined) {
            this.socket.emit("message", JSON.stringify({command, data, forwardMessage}))
        }
    }

    public joinRoom(room: string) {
        this.emit(Topic.joinRoom, {room})
    }

    public on(command: string, listener: any): void {
        this.eventEmitter.on(command, listener)
    }

    public off(command: string, listener: any): void {
        this.eventEmitter.off(command, listener)
    }

    public removeAllListeners(command: string): void {
        this.eventEmitter.removeAllListeners(command)
    }
}
